import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader, Breadcrumbs } from '@/components/layout'
import { PropertyGeneralFields } from '@/components/properties/PropertyGeneralFields'
import { track } from '@/lib/analytics'
import type { Property } from '@/types'

export function PropertyFormPage() {
  const navigate = useNavigate()
  const { t } = useTranslation('properties')

  const handleSave = (saved: Property) => {
    // C4 — feature_used event: property creation is the first activation step.
    track('feature_used', { feature: 'property_create' })
    navigate(`/properties/${saved.id}`)
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs
        items={[
          { label: t('title'), href: '/properties' },
          { label: t('new_property') },
        ]}
      />

      <PageHeader
        title={t('new_property')}
        description={t('new_description')}
      />

      <PropertyGeneralFields property={null} onSave={handleSave} />
    </div>
  )
}
